var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#9BA2B6",
        height: "21",
        viewBox: "0 0 26 21",
        width: "26",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M24.247 9.356c-.37-.03-.765-.312-1.37-.577-1.492-.652-3.029-.999-4.673-.927-1.142.05-.838-.309-.838-.309l2.076-1.384c.493-.361.397-.657-.211-.657h-3.392c-.609 0-1.26-.478-1.449-1.063L13.342 1.18c-.188-.584-.496-.584-.684 0L11.61 4.44c-.188.585-.84 1.063-1.45 1.063H6.77c-.61 0-.705.296-.212.657l1.867 1.37s.331.362-.173.323c-1.643-.125-3.182.275-4.674.928-.605.264-1.173.754-1.833.754-.562 0-.934-.254-1.537-.254-.633 0 .293 4.726 1.246 6.923.56 1.285 1.348 2.395 2.5 3.2 1.859 1.304 3.887 1.621 6.036.883.474-.162.9-.49 1.326-.774.672-.452 1.348-.763 1.932-.763.584 0 1.218.311 1.891.763.426.286.851.612 1.326.774 2.149.738 4.177.42 6.037-.882 1.15-.806 1.94-1.916 2.497-3.201.956-2.197 1.001-4.37 1.001-7.075 0-.332-1.316.263-1.753.228zm-13.898 6.729c-.895.903-2.942 1.492-5.046.382-2.105-1.11-3.472-3.496-2.577-4.4.263-.266 2.705-1.033 4.81.075 2.105 1.11 3.082 3.67 2.813 3.943zm10.805.382c-2.105 1.11-4.153.521-5.048-.382-.378-.382.708-2.833 2.813-3.943 2.106-1.108 4.46-.429 4.81-.075.895.904-.47 3.29-2.575 4.4z",
          "fill-rule": "nonzero",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }